import PubSub from 'underpub-js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

var AnimatedTextReveal = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'atom-AnimatedTextReveal',
    animation: {
      delay: 0,
      speed: 0.5,
      keepLines: false,
      onLoad: true,
    },
  };

  $.extend(true, this.options, options);
};

AnimatedTextReveal.prototype.init = function() {
  const self = this;

  self.$el = self.options.$el;
  self.data.animation.delay =
    self.$el.data('animation-delay') || self.data.animation.delay;
  self.data.animation.speed =
    self.$el.data('animation-speed') || self.data.animation.speed;
  self.data.animation.keepLines =
    typeof self.$el.data('animation-keep-lines') == undefined
      ? self.data.animation.keepLines
      : self.$el.data('animation-keep-lines');
  self.data.animation.onLoad =
    typeof self.$el.data('animation-on-load') == undefined
      ? self.data.animation.onLoad
      : self.$el.data('animation-on-load');

  PubSub.subscribe('loaded', () => self.initOnScrollAnimation());
};

AnimatedTextReveal.prototype.initOnScrollAnimation = function() {
  const self = this;

  function cleanText(e) {
    if (typeof e === 'string') {
      return cleanText(document.querySelectorAll(e));
    } else if (e[0] && e[0].innerHTML) {
      for (var i = 0; i < e.length; i++) {
        cleanText(e[i]);
      }
      return;
    }
    e.innerHTML = e.innerHTML
      .replace(/\-/g, '&#8209;')
      .replace(/V/g, '&zwnj;V&zwnj;')
      .replace(/\./g, '&zwnj;.&zwnj;')
      .replace(/,/g, '&zwnj;,&zwnj;')
      .replace(/A/g, '&zwnj;A&zwnj;')
      .replace(/fi/g, 'f&zwnj;i');
  }

  cleanText(self.$el);

  const linesClass = `${self.data.baseClass}__line`;
  const linesInnerClass = `${linesClass}__inner`;

  const splitText = new SplitText(self.$el, {
    type: 'lines',
    linesClass: linesClass,
  });

  self.$lines = self.$el.find(`.${linesClass}`);

  self.$lines.each((i, line) => {
    $(line).wrapInner(`<span class="${linesInnerClass}"></span>`);
  });

  self.$linesInner = self.$lines.find(`.${linesInnerClass}`);

  const tl = gsap
    .timeline({
      scrollTrigger: self.data.animation.onLoad && {
        trigger: self.$el,
        start: 'top 95%',
      },
      delay: self.data.animation.delay,
    })
    .set(self.$lines, {
      // Matches the xPercent on Lines Inner
      paddingLeft: '5%',
      marginLeft: '-5%',
    })
    .to(self.$el, {
      duration: 0.3,
      ease: 'expo.easeout',
      opacity: 1,
      visibility: 'visible',
    })
    .from(self.$linesInner, {
      duration: self.data.animation.speed,
      ease: 'expo.easeout',
      opacity: 0,
      yPercent: 100,
      skewX: -15,
      xPercent: -5,
      stagger: 0.08,
    })
    .add(() => !self.data.animation.keepLines && splitText.revert());

  self.$el.on('animateIn', () => tl.timeScale(1).play());
  self.$el.on('animateOut', () => tl.timeScale(2.3).reverse());
  self.$el.on('reset', () => !tl.reversed() && tl.pause(0));
};

export default AnimatedTextReveal;
